<h2 mat-dialog-title>
  Update MAT Account Details
</h2>
<button type="button" class="btn btn-link modal-close" (click)="cancel()">
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 6L6 18" stroke="#03101F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M6 6L18 18" stroke="#03101F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</button>
<mat-dialog-content>
  <form class="content-box non-tab edit-account-detail-tab" [formGroup]="matAccountForm">
    <div class="row my-2">
      <div class="col-sm-6">
        <div class="mb-0">
          <span class="black-text fs-14 mb-1">MAT Account Name</span>
          <input type="text" [required]="true" formControlName="clientAccountName" class="form-control bg-zircon mt-1" 
              [readOnly]="!this.canEditName" [class.is-invalid]="
                matAccountForm.controls['clientAccountName'].invalid &&
                matAccountForm.controls['clientAccountName'].touched" />
        </div>
        <div *ngIf="
            (matAccountForm.controls['clientAccountName'].invalid &&
              matAccountForm.controls['clientAccountName'].touched) ||
            matAccountForm.controls['clientAccountName'].dirty">
          <small *ngIf="matAccountForm.controls['clientAccountName'].errors?.['required']"
            class="text-danger fs-13">MAT account name is required</small>
          <small *ngIf="matAccountForm.controls['clientAccountName'].errors?.['pattern']"
            class="text-danger fs-13">Please provide a valid MAT account name</small>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="mb-0">
          <span class="black-text fs-14 mb-1">Account Reference</span>
          <input type="text" [required]="true" formControlName="clientReference" class="form-control bg-zircon mt-1"
              [readOnly]="!this.canEditCode" [class.is-invalid]="
                matAccountForm.controls['clientReference'].invalid &&
                matAccountForm.controls['clientReference'].touched" />
        </div>
        <div *ngIf="
            (matAccountForm.controls['clientReference'].invalid &&
              matAccountForm.controls['clientReference'].touched) ||
            matAccountForm.controls['clientReference'].dirty">
          <small *ngIf="matAccountForm.controls['clientReference'].errors?.['required']"
            class="text-danger fs-13">Account reference is required</small>
          <small *ngIf="matAccountForm.controls['clientReference'].errors?.['pattern']"
            class="text-danger fs-13">Please provide a valid account reference</small>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="">
          <div class="d-flex">
            <p class="black-text fs-14 mb-1">Number of MAT Admin to be created</p>
            <mat-icon matTooltip="Provide the number of MAT Admins to be created under this MAT account"
              class="fs-22 ms-2">info</mat-icon>
          </div>
          <div class="input-container">
            <input type="number" min="1" [required]="true" formControlName="numberOfClientAdmin" class="form-control bg-zircon"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57" [class.is-invalid]="
                      matAccountForm.controls['numberOfClientAdmin'].invalid &&
                      matAccountForm.controls['numberOfClientAdmin'].touched" />
          </div>
        </div>
        <div *ngIf="
            (matAccountForm.controls['numberOfClientAdmin'].invalid &&
             matAccountForm.controls['numberOfClientAdmin'].touched) ||
             matAccountForm.controls['numberOfClientAdmin'].dirty">
          <small *ngIf="matAccountForm.controls['numberOfClientAdmin'].errors?.['required']" class="text-danger fs-13">Number
            of MAT admin to be created is required</small>
        </div>
      </div>
      <div class="col-sm-6 assign-account-admin">
        <div class="mb-4 edit-account-selectoption">
          <div class="d-flex">
          <mat-label class="black-text fs-14 mb-1">Assign Account Admin</mat-label>
          <mat-icon matTooltip="Assign an Account Admin for the MAT Account you are creating" class="fs-22 ms-2">info</mat-icon>
        </div>
          <mat-form-field>
            <mat-select [required]="true" formControlName="assignedAccountAdmin" [class.is-invalid]="
                matAccountForm.controls['assignedAccountAdmin'].invalid &&
                matAccountForm.controls['assignedAccountAdmin'].touched">
              @for (accountAdmin of accountAdminList; track accountAdmin) {
              <mat-option [value]="accountAdmin">{{
                accountAdmin.firstName?.concat(" " + accountAdmin.lastName || "")
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <div *ngIf="
              (matAccountForm.controls['assignedAccountAdmin'].invalid &&
                matAccountForm.controls['assignedAccountAdmin'].touched) ||
              matAccountForm.controls['assignedAccountAdmin'].dirty">
            <small *ngIf="matAccountForm.controls['assignedAccountAdmin'].errors?.['required']"
              class="text-danger fs-13">Account admin is required</small>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="">
          <span class="black-text fs-14 mb-1">Notes</span>
          <textarea [required]="true" class="form-control bg-zircon" formControlName="notes" rows="3" [class.is-invalid]="
              matAccountForm.controls['notes'].invalid &&
              matAccountForm.controls['notes'].touched
            ">
          </textarea>
          <div *ngIf="
              (matAccountForm.controls['notes'].invalid &&
                matAccountForm.controls['notes'].touched) ||
              matAccountForm.controls['notes'].dirty
            ">
            <small *ngIf="matAccountForm.controls['notes'].errors?.['required']" class="text-danger fs-13">Notes is
              required
            </small>
            <small
              *ngIf="matAccountForm.controls['notes'].errors?.['pattern']"
              class="text-danger fs-13"
              >Please provide a valid note
              </small>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="mb-4">
          <div class="d-flex">
            <span class="black-text fs-14 mb-1">Upload</span>
            <mat-icon matTooltip="Attach documents related to MAT Account" class="ms-2 fs-22">info</mat-icon>
          </div>
          <div class="mt-0 px-3 py-3 custom-file-input">
            <div class="file-input-wrapper">
              <span class="file-name">{{ selectedFileCount > 0 ? selectedFileCount + ' file(s) selected' : 'Click to upload' }}</span>
              <input hidden multiple type="file" #editMatFileInput (change)="onFileSelected($event)" />
              <button class="btn theme-btn px-2 ms-3 border-sm-0" mat-raised-button color="primary"
                (click)="uploadFromLocal($event)">
                Upload
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="row">
    <div class="col-sm-12 text-end">
      <button type="button" class="btn theme-btn-outline px-2 px-md-5" (click)="cancel()">
        Cancel
      </button>
      <button type="button" class="btn theme-btn ms-3 px-2 px-md-5" (click)="update()">Update</button>
    </div>
  </div>
</mat-dialog-actions>